<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "~@/styles/variables.scss";
html,
body {
  height: 100%;
  width: 100%;
  min-width: $desktop-width;
  font-family: "Helvetica Neue", "Helvetica", "Hiragino Sans",
    "Hiragino Kaku Gothic ProN", "Arial", "メイリオ", "Yu Gothic", sans-serif;

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background: white;
  }

  #nprogress .bar {
    background: $--color-primary !important;
  }
}
</style>
